import { Card, SegmentedControl, Select, Text, Button } from "@radix-ui/themes";
import { useZonesQuery } from "../../api/pos-api";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAppDispatch } from "../../store";
import { logout } from "../../store/slices/authSlice";
import { ExitIcon } from "@radix-ui/react-icons";

export function Zones() {
  const { data } = useZonesQuery();
  const navigate = useNavigate();
  const [mode, setMode] = useState("autonomous");
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();

  return (
    <div className="w-full h-screen flex items-center justify-center">
      <Button
        disabled={loading}
        className="!absolute !top-6 !right-8"
        variant="ghost"
        color="gray"
        onClick={() => {
          setLoading(true);
          dispatch(logout())
            .unwrap()
            .then(() => {
              setLoading(false);
              navigate("/login");
            });
        }}
      >
        <ExitIcon /> Logout
      </Button>

      <div>
        <Card className="!p-6 shadow-lg rounded-xl min-w-[400px] space-y-5">
          <Text align="center" as="p" weight="bold" size="5" mb="3">
            Select Zone
          </Text>

          <div className="flex flex-col">
            <SegmentedControl.Root value={mode} onValueChange={setMode}>
              <SegmentedControl.Item value="autonomous">Autonomous</SegmentedControl.Item>
              <SegmentedControl.Item value="mobile-app">Mobile App Checkout</SegmentedControl.Item>
              <SegmentedControl.Item value="sku-in-box">Sku In Box</SegmentedControl.Item>
            </SegmentedControl.Root>
          </div>
          <div className="flex flex-col">
            <Select.Root
              onValueChange={(value) => {
                navigate(`zones/${value}/${mode}`);
              }}
            >
              <Select.Trigger placeholder="Select zone" />
              <Select.Content>
                {data?.results.map((zone) => (
                  <Select.Item value={zone.id}>{zone.description}</Select.Item>
                ))}
              </Select.Content>
            </Select.Root>
          </div>
        </Card>
      </div>
    </div>
  );
}
